export default {
  reset: 'אפס',
  action: 'סינון',
  form: {
    action: 'סנן',
    reset: 'אפס הכל',
  },
};
